// extracted by mini-css-extract-plugin
module.exports = {"findDevice__footer":"DeviceSearch_findDevice__footer__fox6W"};